<template>
  <section>
    <TGrid has-vertical-gap>
      <template
        v-for="item in options"
        :key="item"
      >
        <TGridItem :lg="options.length > 2 ? 4 : 6">
          <div class="grid grid-cols-[auto_1fr] gap-3">
            <TIcon
              class="mt-1"
              :icon="['fal', DETAIL_ICONS[item]]"
              size="2xl"
              fixed-width
            />

            <div>
              <strong>{{
                item === DETAIL_TYPES.Delivery ? t(`${item}.title.${rvRentalType}`) : t(`${item}.title`)
              }}</strong>

              <div class="text-gray-500">
                {{
                  item === DETAIL_TYPES.Delivery
                    ? t(`${item}.description`, deliveryDistance)
                    : t(`${item}.description`, { hostName: rvOwnerFirstName })
                }}
              </div>
            </div>
          </div>
        </TGridItem>
      </template>
    </TGrid>
  </section>
</template>

<script setup lang="ts">
import { DETAIL_ICONS, DETAIL_TYPES } from '~/constants/rv'

defineProps<{
  options: DETAIL_TYPES[]
}>()

const { t } = useI18n()

const {
  rvRentalType,
  rvOwnerFirstName,
  rvDeliveryMaxDistance,
  rvMeasurementUnit,
} = useRvDetails()

const deliveryDistance = computed(() => {
  if (!rvDeliveryMaxDistance.value) {
    return {}
  }

  return {
    amount: rvDeliveryMaxDistance.value,
    unit: rvMeasurementUnit.value,
  }
})
</script>

<i18n lang="json">
{
  "en": {
    "delivery": {
      "title": {
        "MotorHome": "Get it delivered",
        "TravelTrailer": "No truck no problem"
      },
      "description": "This host offers delivery up to {amount} {unit}"
    },
    "petfriendly": {
      "title": "Pet friendly",
      "description": "Bring your pet along for the trip"
    },
    "superhost": {
      "title": "Superhost",
      "description": "{hostName} is a Superhost"
    }
  },
  "fr": {
    "delivery": {
      "title": {
        "MotorHome": "Faites-le livrer",
        "TravelTrailer": "Pas de camion pas de problème"
      },
      "description": "Cet hôte offre la livraison jusqu’à {amount} {unit}"
    },
    "petfriendly": {
      "title": "Animaux acceptés",
      "description": "Emmenez votre animal de compagnie avec vous en voyage"
    },
    "superhost": {
      "title": "Superhôtes",
      "description": "{hostName} est Superhôtes"
    }
  }
}
</i18n>
